<template>
  <div class="row pt-5 pb-4 px-5 mx-auto m-4 shadow w-100 border-radius">
    <div class="row justify-content-end w-100 mx-auto">
      <div class="col-4">
        <img class="img-fluid" src="/img/profileIcons/sad.png" alt="" />
      </div>
      <div class="col-4 p-0 my-auto">
          <p><i class="fas fa-arrow-down"></i> 36%</p>
      </div>
    </div>

    <div class="row mt-2 w-100 mx-auto">
      <h3 class="w-100 text-center">Improvements</h3>
    </div>

    <div class="row mt-2 w-100 mx-auto">
      <div class="col-5 text-center">
        <p><strong>Last week</strong></p>
      </div>
      <div class="col-2 text-center"><p>vs</p></div>
      <div class="col-5 text-center">
        <p><strong>This week</strong></p>
      </div>
    </div>

    <div class="row m-0 w-100 mx-auto border-between">

      <div class="col-6 text-center p-3">
        <h1>30</h1>
      </div>

      <div class="col-6 text-center p-3">
        <h1>19</h1>
      </div>

      

    </div>

    <div></div>
  </div>
</template>

<script>
export default {
  mixins: [],
  props: ["user"],
  components: {},

  mounted() {},
  methods: {},
};
</script>

<style scoped lang="scss">
@import "./src/assets/scss/components/engagement/_EmployeeProfile.scss";
</style>